export default {
      id: "instagram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#instagram",
      toString: function () {
        return this.url;
      }
    }